import { render, staticRenderFns } from "./UserDetailPage.vue?vue&type=template&id=c06edfa0&scoped=true&"
import script from "./UserDetailPage.vue?vue&type=script&lang=js&"
export * from "./UserDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailPage.vue?vue&type=style&index=0&id=c06edfa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06edfa0",
  null
  
)

export default component.exports